import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { AgreementsAutocomplete, DiscountsAutocomplete } from "@shared/components/AutocompleteFields";

export function BannerForm() {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="name"
          label={translate("v1/banner_admin.fields.name")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="type"
          label={translate("v1/banner_admin.fields.type")}
          options={[
            { label: "Desconto", value: "discount" },
            { label: "Livro", value: "book" },
          ]}
          required
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.SinglePhotoPicker
          name="image"
          label={translate("v1/banner_admin.fields.image_desktop")}
          shape="square"
          size={150}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.SinglePhotoPicker
          name="image_mobile"
          label={translate("v1/banner_admin.fields.image_mobile")}
          shape="square"
          size={150}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <DiscountsAutocomplete
          name="discount"
          label={translate("v1/banner_admin.fields.discount")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <AgreementsAutocomplete
          name="exclusive_agreements"
          label={translate("v1/banner_admin.fields.exclusive_agreements")}
          multiple
        />
      </Grid>


      <Grid size={{ xs: 12 }}>
        <AgreementsAutocomplete
          name="exclude_agreements"
          label={translate("v1/banner_admin.fields.exclude_agreements")}
          multiple
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="priority"
          label={translate("v1/banner_admin.fields.priority")}
          options={[
            { label: "Baixa", value: 0 },
            { label: "Média", value: 1 },
            { label: "Alta", value: 2 },
          ]}
          required
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="url"
          label={translate("v1/banner_admin.fields.url")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="active"
          label={translate("v1/banner_admin.fields.active")}
          defaultChecked={true}
          required
        />
      </Grid>
    </Grid>

  )
}
